import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
  Stack,
  CircularProgress,
  Fade,
  useTheme,
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const ShareHotelModal = ({ openShareModal, setOpenShareModal }) => {
  const theme = useTheme();

  const [link, setLink] = useState('');

  useEffect(() => {
    setLink(window.location.href);
  }, []);

  const handleClose = () => setOpenShareModal(false);
  const copyLink = () => navigator.clipboard.writeText(link);

  return (
    <Dialog
      open={openShareModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="paper"
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <LinkIcon fontSize="large" />
          <Typography fontWeight={600} fontSize={{ xs: 16, sm: 20 }}>
            Compartir el enlace
          </Typography>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Stack direction="row" alignItems="center" spacing={1}>
          {/* Link Box */}
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              minWidth: 0,
              alignItems: 'center',
              bgcolor: '#E5E5E5',
              borderRadius: 1,
              px: { xs: 1, sm: 2 },
              height: { xs: 40, sm: 50 },
              overflow: 'hidden',
            }}
          >
            {!link ? (
              <Fade in={!link} unmountOnExit>
                <Box
                  sx={{ width: '100%', textAlign: 'center', color: '#636466' }}
                >
                  <CircularProgress size={20} />
                </Box>
              </Fade>
            ) : (
              <Typography
                sx={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  flexShrink: 1,
                  fontSize: 18,
                }}
              >
                {link}
              </Typography>
            )}
          </Box>

          {/* Buttons */}
          <Stack direction="row" spacing={1}>
            <IconButton onClick={copyLink} sx={{ p: 0 }}>
              <FileCopyIcon
                fontSize="small"
                sx={{
                  color: '#fff',
                  bgcolor: theme?.tertiary || '#cdcdcd',
                  borderRadius: '50%',
                  p: 0.875,
                  fontSize: 24,
                  '&:hover': { bgcolor: theme?.tertiary || '#cdcdcd' },
                }}
              />
            </IconButton>

            <IconButton
              onClick={() =>
                window.open(
                  `https://api.whatsapp.com/send?text=Enlace%20de%20busqueda:%20${link}`,
                  '_blank'
                )
              }
              sx={{ p: 0 }}
            >
              <WhatsAppIcon
                fontSize="small"
                sx={{
                  color: '#fff',
                  bgcolor: '#03C868',
                  borderRadius: '50%',
                  p: 0.875,
                  fontSize: 24,
                  '&:hover': { bgcolor: '#03C868' },
                }}
              />
            </IconButton>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ShareHotelModal;
